<template>
    <div class="headerbar">
        <div class="bd container">
            <a>
                <img @click="$router.push('/')" src="../../assets/images/logo.png" alt="" class="logo">
            </a>
            <div class="menu">
                <div class="item" :class="active_index == 0 ? 'active' : ''" @click="$router.push('/')">
                    <i class="icon-1"></i>
                    <span>人工计划</span>
                </div>
                <div class="item" :class="active_index == 1 ? 'active' : ''" @click="$router.push('/plan/index')">
                    <i class="icon-2"></i>
                    <span>公式计划</span>
                </div>
                <a class="item" target="_blank" href="/#/download/app" >
                    <i class="icon-3"></i>
                    <span>下载APP</span>
                </a>
                <a class="item" target="_blank" :href="download_pc">
                    <i class="icon-4"></i>
                    <span>下载电脑版</span>
                </a> 
                <!-- <a class="item" :class="active_index == 4 ? 'active' : ''" @click="routerMember">
                    <i class="icon-5"></i>
                    <span>个人中心</span>
                </a> -->
                <!-- <a class="item" @click="openKefu">
                    <i class="icon-kefu"></i>
                    <span>在线客服</span>
                </a> -->
            </div>            
        </div>
    </div>
</template>

<script>
    import { getConfig } from '@/api/config.js';
    import { mapGetters } from 'vuex';
    export default {
        data() {
            return {
                active_index: 0,
                download_pc : "",
                config: {}
            };
        },
        watch:{
            $route: {
                handler: function(val){
                    switch (this.$route.name) {
                        case 'planIndex':
                            this.active_index = 1;
                            break;
                        case 'memberIndex':
                        case 'memberRecharge':
                        case 'memberShare':
                            this.active_index = 4;
                            break;                  
                        default:
                            this.active_index = 0;
                            break;
                    }
                    //推广地址进入页面
                    if(val.path == "/" && val.query.code) {
                        try {
                            window.localStorage.setItem("regCode", val.query.code);
                        } catch (error) {
                            ;
                        }
                    }
                },
                immediate: true
            },
        },
        created () {
            getConfig().then((response)=>{
                if (response.data.code == 200) {
                    this.config = response.data.data;
                    this.download_pc = response.data.data.pc;
                }
            });
        },
        computed: {
            ...mapGetters(['token','account'])
        },
        methods: {            
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            routerMember() {
                if(this.token) {
                    this.$router.push('/member/recharge')
                } else {
                    this.$eventBus.$emit('showLoginReg','login');
                }                
            },
            openKefu() {

            }
        }
    }
</script>

<style lang="scss">
.headerbar {
    width: 100%;
    height: 85px;
    clear: both;
    background: #fff;
    background: linear-gradient(#ffffff, #EEE1D1);
    display: flex;
    .bd {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
            max-height: 80px;
        }
    }
    .menu {
        display: flex;
        width: 650px;
        justify-content: space-between;   
        align-items: center;
        height: 100%;   

        .item {
            text-align: center;
            height: 100%;
            flex: 1;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            span {
                color: #000;
            }
            + .item {
                margin-left: 10px;
            }
            &.active,&:hover{
                background: linear-gradient(#F0C262, #774C1F);
                color: #ffffff;
                span {
                    color: #ffffff;
                }
                .icon-1 {
                    background-image: url('../../assets/images/nav_01_select.png');
                }
                .icon-2 {
                    background-image: url('../../assets/images/nav_02_select.png');
                }
                .icon-3 {
                    background-image: url('../../assets/images/nav_03_select.png');
                }
                .icon-4 {
                    background-image: url('../../assets/images/nav_04_select.png');                   
                }
                .icon-5 {
                    background-image: url('../../assets/images/nav_05_select.png');                   
                }
                .icon-kefu {
                background-image: url('../../assets/images/nav_kefu_select.png');                   
            }
            }
            i {
                background-repeat: no-repeat;
                background-position: center center; 
                height: 40px;     
                width: 40px;    
                display: inline-block;
            }
            .icon-1 {
                background-image: url('../../assets/images/nav_01.png');
            }
            .icon-2 {
                background-image: url('../../assets/images/nav_02.png');
            }
            .icon-3 {
                background-image: url('../../assets/images/nav_03.png');
            }
            .icon-4 {
                background-image: url('../../assets/images/nav_04.png');
            }
            .icon-5 {
                background-image: url('../../assets/images/nav_05.png');
            }
            .icon-kefu {
                background-image: url('../../assets/images/nav_kefu.png');                   
            }
            span {
                display: block;
                margin-top: 5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue